module.exports = __webpack_public_path__ + "img/cart.aa731cdd.png";